// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/page_theme_schema.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Luminance } from "../../enum/v1/luminance_pb.js";
import { Media } from "./media_pb.js";
import { HeaderImageStyle } from "../../enum/v1/header_image_style_pb.js";

/**
 * @generated from message fingertip.common.type.v1.PageThemeSchema
 */
export const PageThemeSchema = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.PageThemeSchema",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "luminance", kind: "enum", T: proto3.getEnumType(Luminance) },
    { no: 9, name: "heading_font_family", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "body_font_family", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "text_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "heading_text_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "heading_font_weight", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "body_text_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "body_muted_text_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "body_font_weight", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "widget_background", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "widget_backdrop_blur", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "widget_border_radius", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "widget_border_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "widget_border_width", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 23, name: "widget_shadow", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "widget_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "primary_button_text_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "primary_button_border_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "primary_button_border_width", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 29, name: "primary_button_background", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "primary_button_backdrop_blur", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "primary_button_shadow", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "primary_button_font_weight", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 34, name: "button_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "secondary_button_text_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "secondary_button_border_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "secondary_button_border_width", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 39, name: "secondary_button_background", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "secondary_button_backdrop_blur", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "secondary_button_shadow", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "secondary_button_font_weight", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "divider_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 47, name: "card_text_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 48, name: "card_border_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 49, name: "card_border_width", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 50, name: "card_background", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 51, name: "card_backdrop_blur", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 52, name: "card_shadow", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 53, name: "card_icon_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 54, name: "card_secondary_background", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 55, name: "card_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 56, name: "icon_box_background", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 57, name: "icon_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 58, name: "icon_box_border_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 59, name: "icon_box_border_width", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 60, name: "icon_box_shadow", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 62, name: "icon_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 63, name: "input_placeholder_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 64, name: "input_border_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 65, name: "input_text_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 66, name: "input_border_width", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 68, name: "input_background", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 69, name: "input_icon_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 70, name: "input_shadow", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 71, name: "input_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 74, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 75, name: "css", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 76, name: "media", kind: "message", T: Media },
    { no: 77, name: "header_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 78, name: "footer_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 79, name: "parent_page_theme_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 80, name: "header_image_style", kind: "enum", T: proto3.getEnumType(HeaderImageStyle) },
  ],
);

